/**
 * Performs some light formatting on accepted file types for UI feedback.
 *
 * @param {string} types Accepted file type values, as a string.
 * @returns A formatted string fragment.
 */
export const invalidFileTypeFragment = (types = ''): string =>
  types
    .split(',')
    .map((type) => type.trim().split('/').pop().toUpperCase())
    .join(', ');

/**
 * Evaluates whether or not a particular file type matches the accepted types.
 *
 * @param {Object} file A user submitted file.
 * @param {string} acceptedFileTypes Accepted file type values, as a string.
 * @returns A boolean of whether or not the file type is valid.
 */
export const isValidFileType = (file, acceptedFileTypes = ''): boolean => {
  if (!acceptedFileTypes) return false;

  return acceptedFileTypes
    .split(',')
    .map((type) => type.trim())
    .includes(file?.type);
};
